import { _js } from '@ifixit/utils/localize';
import { StatusNotice } from 'Shared/status_notice';
import { FormLibrary } from 'Shared/utils/form-library';

// eslint-disable-next-line no-var
export var AutoPreview = new Class({
   Implements: Options,

   options: {
      period: 3000,
      hideAtFirst: true,
   },

   initialize: function (formid, previewContainerid, previewCallback, options, previewAreaOptions) {
      if (options != null) {
         this.setOptions(options);
      }

      this.form = $(formid);
      this.previewContainer = $(previewContainerid);
      this.previewCallback = previewCallback;
      this.blankInfo = {};
      this.oldInfo = {};
      // Deal with options at some point.

      let h2 = new Element('h2', {
         class: 'muted',
         html: _js('Preview'),
      });

      this.previewArea = new Element('div', previewAreaOptions);

      if (this.options.hideAtFirst) {
         this.previewContainer.addClass('hidden');
      } else {
         this.previewContainer.removeClass('hidden');
         this.update();
      }

      this.previewContainer.adopt(h2);
      this.previewContainer.adopt(this.previewArea);

      this.blankInfo = this.oldInfo = FormLibrary.getValues(this.form);
      this.interval = setInterval(this.checkForQuestionChanges.bind(this), this.options.period);
   },

   // Failures are surfaced only for clicks (callback present): clicking
   // again is the retry, while the poll's next attempt comes when the
   // values change again, so a failing endpoint is never polled in a loop.
   checkForQuestionChanges: function (event, callback) {
      let info = FormLibrary.getValues(this.form);
      if (!this.areEqual(info, this.oldInfo) || !this.areEqual(this.oldInfo, info)) {
         window.iFixit_hasChanged = true;
      } else if (!callback) {
         return;
      }
      this.oldInfo = info;
      return this.update().then(callback, () => {
         // The submit button lives inside the container the callback
         // reveals, so a silent failure would hide the only way to save.
         if (callback) {
            this.showFailure();
            callback();
         }
      });
   },

   showFailure: function () {
      const notice = new StatusNotice();
      notice.error(_js('The preview could not be loaded. Please try again.'));
      this.previewArea.empty();
      this.previewArea.append(notice.element);
      this.previewContainer.removeClass('hidden');
   },

   update: function (event) {
      if (typeof event == 'object') {
         event.stop();
      }
      let info = FormLibrary.getValues(this.form);
      let previewArea = this.previewArea;
      return new Request.AjaxIO(this.previewCallback, {
         onSuccess: function (response) {
            previewArea.set('html', response);
            previewArea.getElements('.post-metadata a, .post-details a').each(link => {
               link.erase('href');
               // Make all non-user-entered links in the preview go nowhere.
            });
            previewArea.getElements('a').each(link => {
               link.set('target', '_BLANK');
               // Open all user-entered links in a new window.
            });
            if (response != null && response != '') {
               this.previewContainer.removeClass('hidden');
            } else if (this.options.hideAtFirst) {
               this.previewContainer.addClass('hidden');
            }
         }.bind(this),
      }).send(info);
   },

   areEqual: function (a, b) {
      for (let property in a) {
         if (typeof a[property] == 'object') {
            if (!b[property] || !this.areEqual(a[property], b[property])) {
               return false;
            }
         } else if (a[property] !== b[property]) {
            return false;
         }
      }
      return true;
   },
});
